var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f5",
    d: "m11.94 2.253-2.41 5.61H7.12c-.4 0-.79.03-1.17.11l1-2.4.04-.09.06-.16c.03-.07.05-.13.08-.18 1.16-2.69 2.46-3.53 4.81-2.89m6.79 5.88-.02-.01c-.6-.17-1.21-.26-1.83-.26h-6.26l2.25-5.23.03-.07c.14.05.29.12.44.17l2.21.93c1.23.51 2.09 1.04 2.62 1.68.09.12.17.23.25.36.09.14.16.28.2.43.04.09.07.17.09.26.15.51.16 1.09.02 1.74m-6.21 9.57h.25c.3 0 .55-.27.55-.6 0-.42-.12-.48-.38-.58l-.42-.15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f5",
    d: "M18.29 9.563c-.45-.13-.92-.2-1.41-.2H7.12q-1.02 0-1.92.39a4.89 4.89 0 0 0-2.96 4.49v1.95c0 .24.02.47.05.71.22 3.18 1.92 4.88 5.1 5.09.23.03.46.05.71.05h7.8c3.7 0 5.65-1.76 5.84-5.26.01-.19.02-.39.02-.59v-1.95a4.9 4.9 0 0 0-3.47-4.68m-5.01 5.98c.46.16 1.08.5 1.08 1.56 0 .91-.71 1.64-1.59 1.64h-.25v.22c0 .29-.23.52-.52.52s-.52-.23-.52-.52v-.22h-.09c-.96 0-1.75-.81-1.75-1.81 0-.29.23-.52.52-.52s.52.23.52.52c0 .42.32.77.71.77h.09v-1.69l-.76-.27c-.46-.16-1.08-.5-1.08-1.56 0-.91.71-1.64 1.59-1.64h.25v-.22c0-.29.23-.52.52-.52s.52.23.52.52v.22h.09c.96 0 1.75.81 1.75 1.81 0 .29-.23.52-.52.52s-.52-.23-.52-.52c0-.42-.32-.77-.71-.77h-.09v1.69z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f5",
    d: "M10.68 14.183c0 .42.12.48.38.58l.42.15v-1.33h-.25c-.31 0-.55.27-.55.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWallet);
export default __webpack_public_path__ + "static/media/white-wallet.0ddc0645044d1da139d65716db49ee89.svg";
export { ForwardRef as ReactComponent };